import AutomationList from './AutomationList';
import Automations from './automations';

export default {
    list: Automations,
};
